import BasketIconHandler from "./BasketIconHandler.js";

export default class BasketHandler
{
    constructor() {
        this.basketIcons = new BasketIconHandler()

        this.backend = '/wp-json/basket/v1'

        window.addEventListener('load', () => this.init())
    }

    init() {
        const data = localStorage.getItem('basket')

        if (data) {
            const contents = JSON.parse(data)
            this.basketIcons.load(contents.products)
            this.save(contents, true)
        } else {
            this.basketIcons.load(0)
        }

        const basketForm = document.querySelector('form#add-to-basket')
        if (basketForm && basketForm.hasAttribute('data-product')) {
            const product = parseInt(basketForm.getAttribute('data-product'))
            basketForm.addEventListener('submit', e => {
                e.preventDefault()
                e.stopPropagation()

                const amount = parseFloat(basketForm.querySelector('#amount').value)
                if (!amount) {
                    return
                }

                basketForm.classList.add('loading')

                this.post('/add', { product, amount })
                    .then(res => {
                        basketForm.classList.remove('loading')
                        basketForm.classList.add('saved')

                        this.save(res)

                        setTimeout(() => {
                            basketForm.classList.remove('saved')
                        }, 1000)
                    })
            })
        }

        document.querySelectorAll('.basket-wrap td.amount input[type="number"]').forEach(input => {
            if (input.hasAttribute('data-orig')) {
                const originalValue = parseInt(input.getAttribute('data-orig'))
                input.addEventListener('change', () => {
                    const value = parseInt(input.value)
                    if (value !== originalValue) {
                        input.parentElement.querySelector('button').classList.add('shown')
                    } else {
                        input.parentElement.querySelector('button').classList.remove('shown')
                    }
                })
            }
        })

        const addressForm = document.querySelector('.address-form')
        if (addressForm) {
            const formFields = []

            const invoiceForm = addressForm.querySelector('.form.invoice')
            const deliveryForm = addressForm.querySelector('.form.delivery')
            const chkHideDeliveryForm = addressForm.querySelector('#same-address')
            const chkDsvgo = addressForm.querySelector('#dsgvo');
            const btnNext = document.getElementById('btn-next')

            const validateForms = forms => {
                if (!chkDsvgo.checked) {
                    return false;
                }

                const fields = formFields.filter(field => forms.includes(field.form)).map(field => field.field)

                for (const field of fields) {
                    if (!field.validity.valid) {
                        return false;
                    }
                }

                return true;
            }

            const onFieldChange = () => {
                const formsToCheck = [invoiceForm]
                if (!chkHideDeliveryForm.checked) {
                    formsToCheck.push(deliveryForm)
                }
                if (validateForms(formsToCheck)) {
                    btnNext.classList.add('shown')
                } else {
                    btnNext.classList.remove('shown')
                }
            }

            [invoiceForm, deliveryForm].forEach(form => {
                form.querySelectorAll('input, textarea').forEach(field => {
                    formFields.push({ form, field })
                })
            })

            formFields.forEach(({ form, field }) => {
                const name = field.getAttribute('name')
                let [_, formCode, fieldName] = name.split('[')
                // formCode = formCode.replace(']', '')
                fieldName = fieldName.replace(']', '')

                field.addEventListener('keyup', e => onFieldChange(form, field, fieldName, e))
                field.addEventListener('change', e => onFieldChange(form, field, fieldName, e))
            })

            const handleChkDeliveryForm = () => {
                if (!chkHideDeliveryForm.checked && !addressForm.classList.contains('show-delivery-form')) {
                    addressForm.classList.add('show-delivery-form')
                }
                if (chkHideDeliveryForm.checked && addressForm.classList.contains('show-delivery-form')) {
                    addressForm.classList.remove('show-delivery-form')
                }

                formFields
                    .filter(field => field.form.classList.contains('delivery'))
                    .map(field => field.field)
                    .forEach(field => {
                        if (chkHideDeliveryForm.checked && field.required) {
                            field.setAttribute('data-required', 1)
                            field.required = false
                        }
                        if (!chkHideDeliveryForm.checked && field.hasAttribute('data-required')) {
                            field.required = true
                        }
                    })
                onFieldChange()
            }

            handleChkDeliveryForm()
            chkHideDeliveryForm.addEventListener('change', handleChkDeliveryForm)
            chkDsvgo.addEventListener('change', onFieldChange)
        }

        const basketPayment = document.querySelector('.form.basket-payment')
        if (basketPayment) {
            const radios = basketPayment.querySelectorAll('input')
            const btnNext = document.getElementById('btn-next')

            const onChange = () => {
                const checkedRadio = Array.from(radios).filter(r => r.checked)
                if (checkedRadio.length) {
                    btnNext.classList.add('shown')
                } else {
                    btnNext.classList.remove('shown')
                }
            }

            onChange()
            radios.forEach(radio => radio.addEventListener('change', onChange))
        }

        window.initQuickBasketIcons = () => {
            if (typeof window.initDiscounts !== 'undefined') {
                window.initDiscounts()
            }

            document.querySelectorAll('.quick-add-to-basket').forEach(button => {
                if (button.hasAttribute('data-initialized')) {
                    return
                }

                button.setAttribute('data-initialized', 'true')

                button.addEventListener('click', () => {
                    const product = parseInt(button.getAttribute('data-product'))
                    const amountField = document.querySelector(`#amount-${product}`)

                    if (amountField) {
                        const amount = parseInt(amountField.value)

                        button.classList.add('saving')
                        amountField.setAttribute('disabled', 'disabled')

                        this.post('/add', { product, amount })
                            .then(res => {
                                this.save(res)
                                button.removeAttribute('disabled')

                                button.classList.remove('saving')
                                button.classList.add('saved')
                                amountField.removeAttribute('disabled')

                                setTimeout(() => {
                                    button.classList.remove('saved')
                                }, 1000)
                            })
                    }
                })
            })
        }

        initQuickBasketIcons()

        this.load()
    }

    save(res, initial = false) {
        this.basketIcons.setValue(res.products, initial)

        localStorage.setItem('basket', JSON.stringify(res))
    }

    load() {
        this.get('/get').then(res => {
            this.save(res, true)
        })
    }

    add(product, amount) {
        this.post('/add', { product, amount }).then(res => {
            console.log('add', res)
        })
    }

    get(path) {
        return fetch(this.backend + path)
            .then(res => res.json())
    }

    post(path, data) {
        return fetch(this.backend + path, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(data)
        })
            .then(res => res.json())
    }
}
